import { SubHeader } from 'components';
import { LoadingPlaceholder } from 'components/LoadingPlaceholder/LoadingPlaceholder';
import { CACHE_FIRST, EDITOR_PATH_ID, ENTITY_PATH } from 'contracts/constants';
import Endpoints from 'pages/packages/package/Endpoints';
import Flows from 'pages/packages/package/Flows';
import Mappings from 'pages/packages/package/Mappings';
import Package from 'pages/packages/package/Package';
import Structures from 'pages/packages/package/Structures';
import Endpoint from 'pages/packages/package/endpoint/Endpoint';
import Flow from 'pages/packages/package/flow/Flow';
import FlowEditorContainer from 'pages/packages/package/flow/FlowEditorContainer';
import Mapping from 'pages/packages/package/mapping/Mapping';
import MappingEditorContainer from 'pages/packages/package/mapping/MappingEditorContainer';
import Structure from 'pages/packages/package/structure/Structure';
import { Route, useLocation, useRouteMatch } from 'react-router-dom';
import { useGetPackageVersionQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';
import { isPackageEditable } from 'utils/is-package-editable';
import ContentWithGrid from './ContentWithGrid';

const PackageRouter = () => {
  const { url } = useRouteMatch();
  const { pathname } = useLocation();

  const params: any = getParams(pathname, [EDITOR_PATH_ID, ENTITY_PATH]);

  const { data, loading } = useGetPackageVersionQuery({
    variables: {
      uuid: params?.versionUuid
    },
    skip: !params?.versionUuid,
    ...CACHE_FIRST
  });

  const isEditable: boolean = data?.getPackageVersion.status
    ? isPackageEditable(data?.getPackageVersion.status)
    : false;

  const debug = <div>Debug</div>;
  const loadingDiv = loading ? <LoadingPlaceholder /> : null;
  const routes = [
    { path: 'package', element: loadingDiv || <Package isEditable={isEditable} /> },
    { path: 'endpoints', element: loadingDiv || <Endpoints isEditable={isEditable} /> },
    { path: 'endpoints/:endpointId', element: loadingDiv || <Endpoint isEditable={isEditable} /> },
    { path: 'structures', element: loadingDiv || <Structures isEditable={isEditable} /> },
    { path: 'structures/:structureId', element: loadingDiv || <Structure isEditable={isEditable} /> },
    { path: 'mappings', element: loadingDiv || <Mappings isEditable={isEditable} /> },
    { path: 'mappings/:mappingId', element: loadingDiv || <Mapping locked={isEditable === false} /> },
    { path: 'flows', element: loadingDiv || <Flows isEditable={isEditable} /> },
    { path: 'flows/:flowId', element: loadingDiv || <Flow /> },
    {
      path: 'flows/editor/:flowId',
      element: loadingDiv || <FlowEditorContainer isEditable={isEditable} />,
      noWrapper: true
    },
    {
      path: 'mappings/editor/:mappingId',
      element: loadingDiv || <MappingEditorContainer />,
      noWrapper: true
    }
  ];

  return (
    <>
      <SubHeader isEditable={isEditable} />
      {routes.map(route => (
        <Route exact path={`${url}/${route.path}`} key={route.path}>
          {route.noWrapper ? route.element : <ContentWithGrid>{route.element}</ContentWithGrid>}
        </Route>
      ))}
    </>
  );
};

export default PackageRouter;
